import dateUtils from './dateUtils'
import stringUtils from './stringUtils'
import noticeUtils from './noticeUtils'
import cacheUtils from './cacheUtils'
import cloneUtils from './cloneUtils'
import regularUtils from './regularUtils'
import utils from './objectUtils'



utils.extends(dateUtils)
utils.extends(stringUtils)
utils.extends(noticeUtils)
utils.extends(cacheUtils)
utils.extends(cloneUtils)
utils.extends(regularUtils)
window.$utils = utils
window.statusCode = {
    Succ: 200,
    Fail: 400,
    Deny: 511,
    Error: 500
}

export default utils



// SELECT  
// +'//'+cate.CategoryName, '/n',
// +CategoryCode +':['
//         + REPLACE(REPLACE(REPLACE(( SELECT  
//                                             '{"CategoryCode" :"'+ item.CategoryCode + '","CategoryID": '
//                                             + CAST(item.CategoryID AS VARCHAR(20))
//                                             + '$n$'+',"CategoryTitle":"'+ item.CategoryName+'"},'
//                                     FROM    T_CategoryInfo item
//                                     WHERE   item.BaseID<>0 AND item.BaseID = cate.CategoryID
//                                   FOR
//                                     XML PATH('')
//                                   ), '$n$', '
// '), '${$', '<'), '$}$', '>') + '
// ], /n'
// FROM    dbo.T_CategoryInfo cate WHERE cate.BaseID=0;



// WEBPACK FOOTER //
// ./src/utils/index.js